import unidecode from 'unidecode';

export const slugNormalizer = (val = '') =>
  unidecode(val)
    .replace(/[^0-9a-z]/gi, '-')
    .toLowerCase();
